import { render, staticRenderFns } from "./AddToCartConfirmationModal.vue?vue&type=template&id=54c92e56"
import script from "./AddToCartConfirmationModal.vue?vue&type=script&lang=js"
export * from "./AddToCartConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports